module.exports = __webpack_public_path__ + "static/media/atu-sligo.bd404d14.png";